module.exports = __webpack_public_path__ + "img/splatoon.e186f09b.png";